<template>
<div>
<div :ref="chart.uuid"></div>
</div>
</template>

<script>
import Plotly from 'plotly.js-dist-min';

export default {
  name: 'ReactiveChart',
	props: ["chart"],
	data() {
		return {
			localDataCopy:[],
			localDataGraph:false
		}
	},
	mounted() {
	let config_to_use
		if (this.chart.hasOwnProperty("displayModeBar") == false){
			
		config_to_use = {displaylogo: false, responsive: true}
		}  else if(this.chart.displayModeBar == true) {
		config_to_use = {displaylogo: false, responsive: true}
		}else{
		config_to_use = {displaylogo: false, responsive: true, displayModeBar: this.chart.displayModeBar}
		}
		if (this.chart.type == "Bubble"){
			console.log("Bubble Graph Plotting")
			this.localDataCopy = this.chart
			this.localDataGraph = true
			  Plotly.newPlot(this.$refs[this.localDataCopy.uuid], {
    data: this.localDataCopy.traces,
    layout: this.localDataCopy.layout,
    frames: this.localDataCopy.frames,
	config: config_to_use
  });
		}
		else{
		Plotly.newPlot(this.$refs[this.chart.uuid], this.chart.traces, this.chart.layout, config_to_use);
		this.localDataGraph = false
		}
		this.$refs[this.chart.uuid].on('plotly_relayout',
    (eventdata)=>{  
        this.$emit("relayout_zoom", eventdata);
	});
	

	},
	watch: {
		chart: {
			handler: function() {

					if (this.chart.type == "Bubble"){
					this.localDataCopy = this.chart
					/*
					//this has been commented out otherwise the pause button doesn't work on the graph
					Plotly.react(this.$refs[this.localDataCopy.uuid], {
							data: this.localDataCopy.traces,
							layout: this.localDataCopy.layout,
							frames: this.localDataCopy.frames,
						});
						*/
					}
					else{
				Plotly.react(
					this.$refs[this.chart.uuid],
					this.chart.traces,
					this.chart.layout,
					this.chart.frames
					);
					}
			},
			deep: true
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>





